import React from 'react'

/* doc
---
title: Card
name: Card
category: React - Bulma
---

A `Card` component based on Bulma `.card`.

See [Bulma Documentation](http://bulma.io/documentation/components/card/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.


```html_example
  <Card>
    <CardContent>
      stuff
    </CardContent>
  </Card>
```
*/
function Card(props) {
  const { children, className, ...rest } = props

  const classes = [
    'bulma card',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

export default Card
